import { throttle } from 'lodash'
import { useState, useEffect, useCallback } from 'react'

export function useScroll () {
  const debouncedListener = useCallback(throttle(() => listener(), 100), [])
  const [lastScrollTop, setLastScrollTop] = useState(0)
  const [bodyOffset, setBodyOffset] = useState(
    document.querySelector('.feed-header')?.getBoundingClientRect()
  )
  const [scrollY, setScrollY] = useState(bodyOffset?.top || 0)
  const [scrollX, setScrollX] = useState(bodyOffset?.left || 0)
  // eslint-disable-next-line
  const listener = e => {
    const offset = document.querySelector('.feed-header')?.getBoundingClientRect()
    
    setBodyOffset(offset)
    setScrollY(-offset.top)
    setScrollX(offset.left)

    setLastScrollTop(Math.abs(offset.top))
  }

  useEffect(() => {
    document.querySelector('.feed-content')?.addEventListener('scroll', debouncedListener)
    return () => {
      document.querySelector('.feed-content')?.removeEventListener('scroll', debouncedListener)
    }
  }, [])

  return {
    scrollY,
    scrollX,
    lastScrollTop,
  }
}
